module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAATBJREFUaEPtWNsNwjAQazdjGJiBigFQmQGGYTMqPiqFiEQ+56pLwfySOLF9r3Qcdv4bd37/QQSiHZQDcqBRgWoInS+PF4t/ux4/sD2x0juJQMmh7hzIL/Tt4mmY1Ai0YlEh1HpojZxVDBEoqcmEEIPV7ABzqHUPGnJwGU1zwHqZt2LWPZsSKJVOJoQYrOYQYg5FFV2x0fVUCO2SgHUm6q4Ti4DjZAsnsVX1iPV6Ukao/j8h5PkMRLCQcSV3HG5k1lBh+oAI5Cqj8wgyv/zsNGolRufAVm/iEALMocge9BMN3AeQQ9HKgWCJQEQVsvaX7pJYBGoKIPMLmnjhSWy1Gv24i4hU60Ehw1yp9KJuwn3Aqnpt/TTdD+v/83x6emHrSemlJIsjB1jlvPbJAS8lWZwFVcDAQEprBaYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr.png
// module id = cNSs
// module chunks = 1